import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsExportButtons = _resolveComponent("StatisticsExportButtons")!

  return (_openBlock(), _createBlock(_component_StatisticsExportButtons, {
    loading: _ctx.isExportProgress,
    permissionCode: _ctx.exportPermission,
    onExportPdf: _ctx.exportPdf,
    onExportExcel: _ctx.exportExcel
  }, null, 8, ["loading", "permissionCode", "onExportPdf", "onExportExcel"]))
}